/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import AppActions from "../components/AppActions";
import AppOptions from "../components/AppOptions";
import BaseCom from "../components/BaseCom";
import FormInput from "../components/FormInput";
import Icon from "../components/Icon";
import L from "../components/Lang";
import { withParamsAndNavigate } from "../components/WithParamsAndNavigate";
import { qreq } from '../shared/qrequest';
import DateTimePicker2 from '../components/DateTimePicker2';
import Globals from '../shared/Globals';
import { Pop } from '../components/PopModal';

class ClientVisit extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            showForm: false,
            appointments: [],
            availabeDates: [],
            info: {
                date: "",
                time: "",
                duration: "30",
                status: "Scheduled",
                notes: ""
            }
        };
    }

    componentDidMount() {
        this.load();
        this.loadProducts();
    }

    componentDidUpdate(prevProps) {
    }

    componentWillUnmount() {
    }

    load = async () => {
        try {
            const j = await qreq.getAsync('/api/visit/client/list');
            if (j.list) {
                this.setState({ appointments: j.list });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    loadProducts = async () => {
        try {
            const j = await qreq.getAsync('/api/product/list/public');
            if (j.list) {
                this.setState({ products: j.list });
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }

    createAppointment = () => {
        this.setState({
            showForm: true,
            info: {
                patientName: "",
                providerName: "",
                visitType: "",
                date: "",
                time: "",
                duration: "30",
                status: "Scheduled",
                notes: ""
            }
        });
    }

    cancelForm = () => {
        this.setState({ showForm: false });
    }

    setValue = (e) => {
        const { name, value } = e.target;

        this.setState({
            info: {
                ...this.state.info,
                [name]: value
            }
        });
    }

    saveAppointment = async (e) => {
        e.preventDefault();

        if (!this.state.info.interested?.length) {
            Pop.show(<L>Please select which products you are interested in.</L>, <L>Missing Information</L>);
            return;
        }

        const info = { ...this.state.info, visitType: {}, scheduleDate: Globals.toISODateString(this.state.info.scheduleDate) };

        const appointment = {
            ...info,
            id: Date.now()
        };

        this.setState({ submitting: true });
        try {
            const j = await qreq.postAsync('/api/visit/client/schedule', info);
            if (j.errorCode === 0) {
                this.success('Scheduled appointment!');
                this.setState({
                    appointments: [...this.state.appointments, appointment],
                    showForm: false,
                    scheduleDate: null,
                    info: {}
                });
                this.load();
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ submitting: false });


    }

    removeAppointment = (id) => {
        Pop.showConfirm(<L>Are you sure you want to cancel this appointment?</L>, <L>Appointment</L>, async () => {
            const info = { id: id };
            try {
                const j = await qreq.postAsync('/api/visit/client/delete', info);
                if (j.errorCode === 0) {
                    this.success('Deleted!');
                    this.setState({
                        appointments: this.state.appointments.filter(x => x.id !== id)
                    });
                    this.load();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        });
    }

    dateClick = (v) => {
        if (!v?.start) return;
        const dt = v.start;
        this.setState({ selectedDT: dt, info: { ...this.state.info, scheduleDate: dt } });
    }

    change = () => {
        this.forceUpdate();
    }

    render() {
        return <div className="container py-4">
            <h1 className="mb-1"><L>Appointments</L></h1>

            {this.state.showForm && <>



                <div className="text-muted my-2"><L>Create new appointment.</L></div>
                <div className="card shadow-sm border-0 mb-4">
                    <div className="card-header bg-white">
                        <strong><L>New Appointment</L></strong>
                    </div>

                    <div className="card-body">
                        {!this.state.info.scheduleDate && <DateTimePicker2 onChange={this.dateClick} />}

                        {this.state.info.scheduleDate && <form onSubmit={this.saveAppointment}>
                            <div className="row g-3">

                                <div className="col-md-4">
                                    <FormInput model={this.state.info}
                                        name="interested"
                                        type="multiselect"
                                        label="Interested In"
                                        options={this.state.products || []}
                                        noSearch
                                        onChange={this.change}
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label className="form-label">Date/Time</label>
                                    <div>
                                        <strong><i>{Globals.toMDYHMISODateString(this.state.info.scheduleDate)}</i></strong>
                                    </div>
                                </div>


                            </div>
                            <AppActions>
                                <button type="submit" className="btn btn-success btn-lg">
                                    <Icon icon="faSave" /> <L>Schedule Now</L>
                                </button>
                            </AppActions>
                        </form>}
                    </div>
                </div>

            </>}

            {!this.state.showForm && <>

                <AppOptions>
                    <button type="button" className="btn btn-primary btn-lg" onClick={this.createAppointment}>
                        <Icon icon="faBookMedical" /> <L>Create Appointment</L>
                    </button>
                </AppOptions>
                <div className="text-muted my-2"><L>Schedule and manage your appointments.</L></div>

                <div className="card shadow-sm border-0">
                    <div className="card-header bg-white d-flex justify-content-between align-items-center">
                        <strong><L>Scheduled Appointments</L></strong>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th><L>Date</L></th>
                                    <th><L>Time</L></th>
                                    <th><L>Status</L></th>
                                    <th className="text-end"><L>Actions</L></th>
                                </tr>
                            </thead>

                            <tbody>
                                {this.state.appointments.length === 0 &&
                                    <tr>
                                        <td colSpan="7" className="text-center text-muted py-5">
                                            <Icon icon="faCalendarAlt" />
                                            <br />
                                            <L>No appointments scheduled.</L>
                                        </td>
                                    </tr>
                                }

                                {this.state.appointments.map(a =>
                                    <tr key={a.id}>
                                        <td>{Globals.toMDYDateString(a.scheduleDate)}</td>
                                        <td>{Globals.toHMTimeString(a.scheduleDate)}</td>

                                        <td>
                                            <span className="badge text-bg-light border">
                                                {a.status}
                                            </span>
                                        </td>

                                        <td className="text-end">
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => this.removeAppointment(a.id)}
                                            >
                                                <Icon icon="faTrash" /> <L>Delete</L>
                                            </button>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </>}
        </div>;
    }
}

export default withParamsAndNavigate(ClientVisit);